import React from "react";
import PageHeader from '../common/PageHeader/PageHeader';
import TVWeeklyScheduleTable from "./tvWeeklyScheduleTable"
import { ReportContext } from "../../layout/Content/MainContent.component";
import useTvWeeklyScheduleStyles from "./tvWeeklySchedule.style"
import Button from '@material-ui/core/Button';
import DialogBox from "../common/Dialog/Dialog.component";
import { useSnackbar } from "notistack";

function TvWeeklySchedule(props) {
    const {
        activeTab,
        handleNext,
        handlePrev,
        networks,
        contentTypes,
        year,
        week,
        period,
        reportType,
        setReportType,
        spec,
        setSpec,
        temp,
        setTemp
    } = React.useContext(ReportContext);
    const classes = useTvWeeklyScheduleStyles();
    const { enqueueSnackbar } = useSnackbar();
    const [zeroContentTypes, setZeroContentTypes] = React.useState({});
    const [openDialog, setOpenDialog] = React.useState(null);

    const validateDays = _ => {
        let isError = false;
        let arr = spec.networks.map(network => {
            let days = {};
            if (zeroContentTypes[network.network].length > 0)
                isError = true;
            network.contentTypes.forEach(contentType => {
                // if (zeroContentTypes[network.network].indexOf(contentType.contentType) > -1) {
                //     if (Object.values(contentType.days).reduce(function (a, b) {
                //         return a + b;
                //     }, 0) === 0) {
                //         isError = true;
                //         itemsWithZeros[network.network].push(contentType.contentType)
                //     }
                //     else {
                //         isfilled = true;
                //         itemsRemovedZeros[network.network].push(contentType.contentType)
                //     }

                // }
                Object.keys(contentType.days).forEach(day => {
                    if (days[day] === undefined) days[day] = 0;
                    days[day] += contentType.days[day];
                })
            })
            return Object.values(days).filter(el => el > 1440).length > 0
        })
        return ({ isError: isError, days: arr.filter(e => e).length > 0 })
    }

    const onNext = e => {
        let temp = validateDays();
        if (!temp.days) {
            setSpec(
                {
                    ...spec,
                    reportName: "Initial",
                    reportType: reportType === "Optimize" ? "optimization" : "simulation",
                    // statusId: 1,
                    // userId: "user@user.com",
                }
            )
            // let t = Object.keys(emp.itemsWithZeros).forEach
            if (!temp.isError) {
                handleNext(activeTab)
            }
            else if (temp.isError) {
                setOpenDialog(zeroContentTypes)
            }
        }
        else {
            enqueueSnackbar("Sum of all content types per Network should not greater than 1440 Mins per a day", {
                variant: 'warning',
                autoHideDuration: 2500
            })
        }

    }
    const getString = data => {
        // let text = ""
        let txt = Object.keys(data).map((key, index) => {
            let text = "";
            if (data[key].length > 0) {
                let arr = contentTypes.filter(el => data[key].indexOf(el.contentType) > -1).map(el => el.contentTypeDisplayName)
                text += "" + arr.join(", ") + " on "
                text += key.toString().toUpperCase();
            }
            return text
        }).filter(el => el !== "");
        return txt.join(" and ");
    }
    return (
        <div style={{ marginTop: 20 }}>
            <PageHeader report={['Optimize', 'Simulate']} defaultValue={reportType} onChange={setReportType} />
            <div style={{ maxHeight: "calc(100vh - 200px)" }}>
                {
                    networks.map((network, index) => <TVWeeklyScheduleTable key={"network_" + index} zeroContentTypes={zeroContentTypes} setZeroContentTypes={setZeroContentTypes} temp={temp} setTemp={setTemp} spec={spec} setSpec={setSpec} period={period} network={network} contentTypes={contentTypes} year={year} week={week} />)
                }
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", padding: "0px 20px", width: "70%", margin: "auto" }}>
                <Button variant="outlined" classes={{ root: classes.button, label: classes.buttonLabel }} onClick={e => handlePrev(activeTab)}>Back</Button>
                <Button variant="outlined" classes={{ root: classes.button, label: classes.buttonLabel }} onClick={onNext}>Next</Button>
            </div>
            {openDialog &&
                <DialogBox open={openDialog !== null} onClose={e => setOpenDialog(null)} onSave={e => handleNext(activeTab)} type={"alert"} title={"Warning"}>
                    <div style={{ padding: 8, fontSize: "0.85rem", fontFamily: "OpenSans" }}>There is no historical information for <b>{getString(openDialog)}</b> for the selected week, the closest week this content type was aired will be used instead for the optimization/simulation</div>
                </DialogBox>}
        </div>
    )
}



export default TvWeeklySchedule;